module.exports = __webpack_public_path__ + "static/img/logo-FREMANTLE.9fed175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-FREMANTLE.svg
// module id = QPIA
// module chunks = 1